import { call, fork, put, take } from 'redux-saga/effects';
import * as notify from '../../containers/layout/Notifications/actions';
import { serviceUnavailable } from '../app/actions';
import { ConnectionError, NotFoundError, ServiceUnavailableError } from '../app/errors';
import { failure, FAILURE, isLoading, setEvents, SUCCESS, success } from './actions';
import { getEvents } from './rest';

export function* handleGetEvents(day, showStarted, marketGroupId) {
  try {
    const results = yield call(getEvents, day, showStarted, marketGroupId);
    yield put(success(results));
  } catch (e) {
    yield put(failure(e));

    if (e instanceof ConnectionError || e instanceof NotFoundError) {
      yield put(notify.add('Connection error.', notify.ERROR));
    } else if (e instanceof ServiceUnavailableError) {
      yield put(serviceUnavailable());
    } else {
      throw e;
    }
  }
}

export function* loadEvents(day, showStarted = false, marketGroupId = null) {
  yield put(isLoading(true));
  yield fork(handleGetEvents, day, showStarted, marketGroupId);
  const { type, results } = yield take([SUCCESS, FAILURE]);
  if (type === SUCCESS) {
    yield put(setEvents(results));
  }
  yield put(isLoading(false));
  return type === SUCCESS;
}
